/*eslint-disable*/
import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getAllProjects, getProjectCount } from "../Actions/projectsAction";
import {
  Layout,
  Typography,
  Spin,
  Modal,
  Row,
  Col,
  Input,
  Checkbox,
  Button,
  message,
} from "antd";
import "./styles/navbar.css";
import HomeFooter from "../components/Footer";
import HomeHeader from "../components/Header";
import BannerImage from "../components/BannerImage";
import Projects from "../components/Projects";
import AdvanceSearch from "../components/advanceSearch";
import AboutUs from "../components/AboutUs";
import PropertyServices from "../components/PropertyServices";
import { getAllAreas } from "../Actions/areasAction";
import Partners from "../components/Partners";
import graphDownIcon from "../assets/images/graphDown.svg";
import handStarsIcon from "../assets/images/handStars.svg";
import percentageIcon from "../assets/images/percentage.svg";
import PropertyOptionsAhmedabad from "../components/PropertyOptionsAhmedabad";
import Leadership from "../components/Leadership";
import DisclaimerBanner from "../components/DisclaimerBanner";
import PropertyTypes from "../components/PropertyType";
import SellPropertySection from "../components/SellPropertySection";
import PropertyQuizSection from "../components/PropertyQuizSection";
import { useBreakpoints } from "../components/ResponsiveBreakPoints";
import EnquiryModal from "./EnquiryModal";

const PropertyType = [
  { value: 0, label: "Flat" },
  { value: 1, label: "Pent House" },
  { value: 2, label: "Bunglow" },
  { value: 3, label: "Tenament" },
  { value: 4, label: "Duplex" },
  { value: 5, label: "Row House" },
  { value: 6, label: "Fam House" },
  { value: 7, label: "Office" },
  { value: 8, label: "Shop" },
  { value: 9, label: "Showroom" },
  { value: 10, label: "Godown" },
  { value: 11, label: "Wear House" },
  { value: 12, label: "Residential" },
  { value: 13, label: "Commercial" },
  { value: 14, label: "Agriculture" },
  { value: 15, label: "NonAgriculture" },
  { value: 16, label: "Redevelopment" },
];

const { Header, Content } = Layout;
const Landing = () => {
  const dispatch = useDispatch();
  const { isMobile } = useBreakpoints();
 
  const [isEnquiryModalOpen, setIsEnquiryModalOpen] = useState(false);
  const { areas } = useSelector((state) => state.areas);
  const [advSearch, setAdvanceSearch] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const mobileInfoRef = useRef(null);
  const popupTimerRef = useRef(null);
  const {
    projects,
    residentialProject,
    commercialProject,
    landProject,
    landProjectPreLaunch,
    landProjectNewR3,
    residentialPreLaunch,
    residentialNew34,
    residentialNew3,
    commercialPreLaunch,
    commercialPreLease,
    preLeaseProjects,
    allProjects,
    isGetProjectsLoading,
  } = useSelector((state) => {
    const {
      projects,
      residentialProject,
      commercialProject,
      landProject,
      landProjectPreLaunch,
      landProjectNewR3,
      residentialPreLaunch,
      residentialNew34,
      residentialNew3,
      commercialPreLaunch,
      commercialPreLease,
      preLeaseProjects,
      isGetProjectsLoading,
      allProjects,
    } = state.projects;
    return {
      projects,
      residentialProject,
      commercialProject,
      landProject,
      landProjectPreLaunch,
      landProjectNewR3,
      residentialPreLaunch,
      residentialNew34,
      residentialNew3,
      commercialPreLaunch,
      commercialPreLease,
      preLeaseProjects,
      isGetProjectsLoading,
      allProjects,
    };
  });


  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("logout_reason") === "displaced") {
      message.error({
        content: "You have been logged out because your account was accessed from another location.",
        duration: 8,
        style: { marginTop: "10vh" }
      });
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  useEffect(() => {
    if (window.__SVMD_ENQUIRY_POPUP_SHOWN__) return;
    window.__SVMD_ENQUIRY_POPUP_SHOWN__ = true;

    const STORAGE_KEY = "svmd_enquiry_popup_time";
    const RESET_AFTER = 24 * 60 * 60 * 1000; // 24 hours
    // const RESET_AFTER = 10 * 1000; // testing

    const lastShown = localStorage.getItem(STORAGE_KEY);
    const now = Date.now();

    if (!lastShown || now - Number(lastShown) > RESET_AFTER) {
      popupTimerRef.current = setTimeout(() => {
        setIsEnquiryModalOpen(true);
        localStorage.setItem(STORAGE_KEY, String(now));
      }, 30000);
    }

    return () => {
      if (popupTimerRef.current) clearTimeout(popupTimerRef.current);
    };
  }, []);

  useEffect(() => {
    const onScroll = () => {
      if (!mobileInfoRef.current) return;

      const top = mobileInfoRef.current.getBoundingClientRect().top;
      const STICKY_TOP = window.innerWidth >= 768 ? 130 : 100;

      setIsSticky(top <= STICKY_TOP);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
    });
    dispatch(getAllProjects("type=Residential&is_sell=true"));
    dispatch(getAllProjects(`type=Residential&pre_launch=true`));
    dispatch(getAllProjects(`type=Residential&new_34=true`));
    dispatch(getAllProjects(`type=Residential&new_3=true`));
    dispatch(getAllProjects(`type=Commercial&is_sell=true`));
    dispatch(getAllProjects(`type=Commercial&pre_launch=true`));
    dispatch(getAllProjects(`type=Commercial&pre_lease=true`));
    dispatch(getAllProjects("type=Land&is_sell=true"));
    dispatch(getAllProjects("type=Land&pre_launch=true"));
    dispatch(getAllProjects("type=Land&new_r3=true"));
    dispatch(getAllAreas());
    dispatch(getProjectCount());
  }, []);

  const projectsData = [
    {
      title: "Trending Residential Projects",
      categories: [
        { label: "New 4/5 BHK", projects: residentialPreLaunch },
        { label: "New 3/4 BHK", projects: residentialNew34 },
        { label: "New 3 BHK", projects: residentialNew3 },
        { label: "Resell", projects: residentialProject },
      ],
    },
    {
      title: "Trending Villas & Plots",
      categories: [
        { label: "New", projects: landProjectPreLaunch },
        { label: "New R3", projects: landProjectNewR3 },
        { label: "Resell", projects: landProject },
      ],
    },
    {
      title: "Trending Commercial Projects",
      categories: [
        { label: "New", projects: commercialPreLaunch },
        { label: "Resell", projects: commercialProject },
        { label: "Pre Lease", projects: commercialPreLease },
      ],
    },
  ];
  const scrollToSection = (sectionId) => {
    const targetElement = document.getElementById(sectionId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleOpenEnquiryModal = (project) => {
    setSelectedProject(project);
    setIsEnquiryModalOpen(true);
  };

  return (
    <>
      <Layout>
        <Header className="header">
          <HomeHeader onScrollToSection={scrollToSection} />
        </Header>

        <Content>
          <BannerImage
            advSearch={advSearch}
            setAdvanceSearch={setAdvanceSearch}
          />
          {advSearch && <AdvanceSearch></AdvanceSearch>}
          <Spin spinning={isGetProjectsLoading}>
            <div style={{ paddingTop: "80px" }}>
              {/* Mobile horizontal info bar */}
              <div
                ref={mobileInfoRef}
                className={`mobile-info-card ${isSticky ? "is-sticky" : ""}`}
              >
                <div className="mobile-card-item">
                  <img src={percentageIcon} alt="percentage" />
                  <span>
                    Zero brokerage
                    <br />
                    on New Properties
                  </span>
                </div>

                <div className="mobile-card-item">
                  <img src={graphDownIcon} alt="graphDown" />
                  <span>
                    Lowest price
                    <br />
                    guarantee
                  </span>
                </div>

                <div className="mobile-card-item">
                  <img src={handStarsIcon} alt="handStars" />
                  <span>
                    Full service
                    <br />
                    support
                  </span>
                </div>
              </div>

              <div className="projects-section">
                <div className="sticky-info">
                  <div className="info-card">
                    <div>
                      <span style={{ fontSize: "18px" }}>
                        <img
                          src={percentageIcon}
                          alt="percentageIcon"
                          style={{ marginBottom: "6px" }}
                        />
                      </span>
                      <br />
                      Zero brokerage on New Properties
                    </div>
                    <div>
                      <span style={{ fontSize: "18px" }}>
                        <img
                          src={graphDownIcon}
                          alt="graphDownIcon"
                          style={{ marginBottom: "6px" }}
                        />
                      </span>
                      <br />
                      Lowest price guarantee
                    </div>
                    <div>
                      <span style={{ fontSize: "18px" }}>
                        <img
                          src={handStarsIcon}
                          alt="handStarsIcon"
                          style={{ marginBottom: "6px" }}
                        />
                      </span>
                      <br />
                      Full service support
                    </div>
                  </div>
                </div>
                <div className="projects-content">
                  {projectsData.map(({ title, categories }) => {
                    return (
                      <Projects
                      key={title}
                        title={title}
                        categories={categories}
                        openEnquiryModal={handleOpenEnquiryModal}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          </Spin>
          <Partners />
          <PropertyTypes />
          <PropertyServices />
          <AboutUs areas={areas} allProjects={allProjects} />
          <Leadership />
          <SellPropertySection />
          <PropertyQuizSection />
          <PropertyOptionsAhmedabad />
        </Content>

        <HomeFooter />
        <DisclaimerBanner />
        <EnquiryModal
          open={isEnquiryModalOpen}
          onCancel={() => setIsEnquiryModalOpen(false)}
          selectedProject={selectedProject}
          setSelectedProject={setSelectedProject}
          setIsEnquiryModalOpen={setIsEnquiryModalOpen}
        />
      </Layout>
    </>
  );
};
export default Landing;
